module.exports = __webpack_public_path__ + "static/img/newsDetail.c58af26.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/news/newsDetail.png
// module id = SRAE
// module chunks = 1